export const CHECK_ON_EXISTING_EMAIL = 'CHECK_ON_EXISTING_EMAIL';
